/**
 * Risk Concentration API Service
 *
 * Type-safe endpoint for concentration risk buckets.
 * Types derived from platform-admin.openapi.yaml -- no manual interfaces.
 *
 * Endpoint:
 *   GET /risk/concentration
 */

import { platformAdminClient } from '../client';
import type { components } from '@aaimplatform/institutional-types/platform-admin';

export type ConcentrationRiskItem = components['schemas']['ConcentrationRiskItem'];
export type ConcentrationRiskResponse = components['schemas']['ConcentrationRiskResponse'];

export const riskConcentrationApi = {
  getConcentration: async (): Promise<ConcentrationRiskResponse> => {
    const { data, error } = await platformAdminClient.GET('/risk/concentration');
    if (error || !data) throw new Error('Failed to fetch concentration risk data');
    return data;
  },
};
